import type { ReactNode } from 'react'

export type PracticeScenarioProps = {
  title: string
  setup: ReactNode
  prompt: ReactNode
  debrief?: ReactNode
}

export default function PracticeScenario({ title, setup, prompt, debrief }: PracticeScenarioProps) {
  return (
    <div className="slide-practice-scenario" data-archetype="practice-scenario">
      <div className="ps-header">
        <span className="ps-badge">Practice Scenario</span>
        <h3 className="ps-title">{title}</h3>
      </div>
      <div className="ps-section ps-section--setup">
        <h4 className="ps-section-title">Setup</h4>
        <div className="ps-section-body">{setup}</div>
      </div>
      <div className="ps-section ps-section--prompt">
        <h4 className="ps-section-title">Your task</h4>
        <div className="ps-section-body">{prompt}</div>
      </div>
      {debrief ? (
        <div className="ps-section ps-section--debrief">
          <h4 className="ps-section-title">Debrief</h4>
          <div className="ps-section-body">{debrief}</div>
        </div>
      ) : null}
    </div>
  )
}
